import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=77f62949&scoped=true&"
var script = {}
import style0 from "./Sobre.vue?vue&type=style&index=0&id=77f62949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f62949",
  null
  
)

export default component.exports